import { render, staticRenderFns } from "./WeeklyWorkLabDetail.vue?vue&type=template&id=bb6b64c2&scoped=true"
import script from "./WeeklyWorkLabDetail.vue?vue&type=script&lang=js"
export * from "./WeeklyWorkLabDetail.vue?vue&type=script&lang=js"
import style0 from "./WeeklyWorkLabDetail.vue?vue&type=style&index=0&id=bb6b64c2&prod&scoped=true&lang=css"
import style1 from "./WeeklyWorkLabDetail.vue?vue&type=style&index=1&id=bb6b64c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6b64c2",
  null
  
)

export default component.exports